.virtualRow {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  overflow-anchor: none;
  contain: layout;
  z-index: 1;
}

.checkboxSlot {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.checkboxSlot[data-position="left"] {
  padding-inline-start: var(--mantine-spacing-xs);
  padding-inline-end: var(--mantine-spacing-sm);
}

.checkboxSlot[data-position="right"] {
  padding-inline-end: var(--mantine-spacing-lg);
}